<template>
    <CModal @mtdclosemodal="mtdClose" :show="boo_modal" :title="title" :size="'lg'" :centered="true" :btn_cancel="true"
        :btn_ok="true" :booTitile="true">
        <!-- Sección de otros egresos -->
        <div>
            <label>Egreso</label>
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th width="60">N°</th>
                        <th>Fecha</th>
                        <th>Tipo de egreso</th>
                        <th>Motivo</th>
                        <th>Monto</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in data" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ new Date(item.created_at).toLocaleDateString('es-ES', {day: '2-digit', month: '2-digit', year:'numeric' }) }}</td>
                        <td>{{ item.expense_type.name }}</td>
                        <td>{{ item.motive }}</td>
                        <td>{{ item.amount }}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="4" class="text-right font-weight-bold">Total:</td>
                        <td class="font-weight-bold">{{ totalAmountReserva() }}</td>
                    </tr>
                </tfoot>
            </table>
        </div>
        <template #footer>
            <button @click="mtdClose" class="btn btn-danger btn-sm">
                <i class="fa fa-times"></i>&nbsp;Cerrar
            </button>
        </template>
    </CModal>
</template>

<script>
import CModal from "../../shared/modals/cModalFormCom.vue";

export default {
    name: "cModalGeneral",
    components: {
        CModal,
    },
    props: {
        title: String,
        boo_modal: Boolean,
        data: Array,           // Lista de ventas de productos
        data_reserva: Array,   // Lista de reservas
    },
    methods: {
        mtdClose() {
            this.$emit("closeModal");
        },
        totalAmountReserva() {
            return this.data?.reduce((total, item) => {
                return total + parseFloat(item.amount);
            }, 0).toFixed(2);
        },
        totalAmount() {
            return this.data?.reduce((total, item) => {
                return total + parseFloat(item.amount);
            }, 0).toFixed(2);
        },
    },
};
</script>

<style scoped></style>